/**
 * IMPORTS
 */

import { ImageOff } from "lucide-react";

interface IModelImageProps {
  src?: string | null;
  alt: string;
}

function ModelImage({ src, alt }: IModelImageProps) {
  if (!src || src === "N/A") {
    return (
      <div
        className="flex h-20 w-full items-center justify-center rounded bg-neutral-100"
        aria-hidden="true"
      >
        <ImageOff className="h-5 w-5 text-neutral-400" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={80}
      height={80}
      loading="lazy"
      className="h-20 w-full rounded object-cover"
    />
  );
}

/**
 * EXPORT
 */
export { ModelImage };